import { createFileRoute } from "@tanstack/react-router";
import FoodGrade from "@/pages/services/FoodGrade";

export const Route = createFileRoute("/services/food-grade")({ component: FoodGrade });